import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const TrashCan = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 448 512" {...props}>
      <path
        opacity={0.2}
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M64 144l0 304c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-304-320 0zm48 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192zM149.5 64l149 0-11-36.6c-2-6.8-8.3-11.4-15.3-11.4l-96.4 0c-7.1 0-13.3 4.6-15.3 11.4L149.5 64zM208 208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M160.5 27.4c2-6.8 8.3-11.4 15.3-11.4l96.4 0c7.1 0 13.3 4.6 15.3 11.4l11 36.6-149 0 11-36.6zM116.1 64L16 64C7.2 64 0 71.2 0 80S7.2 96 16 96l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-100.1 0-13.7-45.8C312.1-2.1 293.4-16 272.2-16l-96.4 0c-21.2 0-39.9 13.9-46 34.2L116.1 64zM32 144l0 304c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304-32 0 0 304c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-304-32 0zm112 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192z"
      />
    </SvgIcon>
  );
};
